// filepath: src/components/SwitcherToggle.jsx
import React from "react";

export default function SwitcherToggle({ isOpen, onToggle }) {
  return (
    <>
      <button
        onClick={onToggle}
        aria-label="Switch account"
        className="switcher-toggle"
        title="Switch account"
      >
        <span className="switcher-desktop">Switch account</span>
        <span className="switcher-mobile" aria-hidden="true">
          {/* Circle with left-right arrows */}
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" role="img">
            <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1.5" />
            <path d="M6 11h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M9 8l-3 3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13 14l3-3-3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>

      <style>{`
        .switcher-toggle{
          display:flex; align-items:center; gap:8px;
          padding:6px 10px; border:1px solid #ddd; border-radius:999px;
          background:#fff; cursor:pointer; font:500 14px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial;
          color: #ff8a00; /* orange arrows/text */
        }
        .switcher-toggle:hover{ background:#fafafa }
        .switcher-desktop{ display:inline }
        .switcher-mobile{ display:none }
        @media (max-width: 768px){
          .switcher-desktop{ display:none }
          .switcher-toggle{ padding:8px; width:36px; height:36px; border-radius:50%; justify-content:center }
          .switcher-mobile{ display:inline-flex }
        }
      `}</style>
    </>
  );
}
